/**
 * Created by WebStorm.
 * User: nirongxu
 * Date: 2018/12/8
 * Description: 文件描述
 */

import en from './en/en'
import cn from './cn/cn'
export default {
  en,
  cn
}



// WEBPACK FOOTER //
// ./src/i18n/lang/index.js